




import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-date-range"
})
export default class UipaidDropdownComponent extends Vue {
  @Model('onSelected', {type: [String, Number, Object, Array]}) value: any | string | number;
  @Watch('value')
  onValueChanged() {
    this.$emit('onSelected', this.value);
  }
  paidOptions = [
    {id: null, name: 'все'},
    {id: true, name: 'платные'},
    {id: false, name: 'бесплатные'}
  ]
}
